module.exports = __webpack_public_path__ + "media/images/icons/country_flags/lr-61e7a9985643d013538dcd486998e606.svg";